import React from 'react';
import {ApolloClient, NormalizedCacheObject} from '@apollo/client';
import {Outlet, useLocation, useParams} from 'react-router-dom';
import {Box} from '@mui/material';
import {BackLink} from './BackLink';

interface Props {
  client: ApolloClient<NormalizedCacheObject>;
}

/**
 * Mobile wrapper for `/profile/:pid` and below. The home page renders its
 * own back link to `/profile`, so this layout only injects a breadcrumb
 * for the drill-in pages (feed, history, channels, video, channel,
 * feedback). The breadcrumb sends the user back to the home, not the
 * profile list — matches the new IA where the home is the hub.
 */
const ProfileLayoutMobile: React.FC<Props> = () => {
  const {pid} = useParams();
  const {pathname} = useLocation();
  const isHome = pathname === `/profile/${pid}` || pathname === `/profile/${pid}/`;
  const isSetup = pathname.startsWith(`/profile/${pid}/setup`);

  return (
    <Box sx={{display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
      {!isHome && !isSetup && (
        <Box sx={{px: 2, pt: 1}}>
          <BackLink to={`/profile/${pid}`} label="back to profile" />
        </Box>
      )}

      {/* No outer Container — pages render their own with the
          width they want. Wrapping in one would force every nested
          page-Container to be at most this layout's width. */}
      <Box component="main" sx={{flexGrow: 1}}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default ProfileLayoutMobile;
